import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyFormatter } from '@x/common/money/currency-formatter';
import { IShopOrder, ShippingCostCalculation } from '@x/ecommerce/shop-client';

@Component({
  selector: 'x-order-totals',
  templateUrl: './order-totals.component.html',
  styleUrls: ['./order-totals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CurrencyFormatter,
      useValue: new CurrencyFormatter({
        trailingZeroDisplay: 'auto',
      } as any),
    },
  ],
  host: { class: 'x-order-totals' },
})
export class OrderTotalsComponent {
  @Input() order: IShopOrder | undefined | null;

  get shippingItem(): IShopOrder['items'][number] | undefined {
    return this.order?.items.filter((i) => i.source === 'SHIPPING')[0];
  }

  get outstandingTotal(): number | undefined {
    if (!this.order) return;

    const total = this.order.total - this.order.paidTotal;

    return total > 0 ? total : undefined;
  }

  get paidTotal(): number | undefined {
    if (!this.order) return;

    return this.order.paidTotal;
  }

  get shipmentCostCalculation(): null | ShippingCostCalculation {
    if (!this.order?.shipment?.costCalculation) return null;

    const shippingItem = this.order?.items.find((i) => i.source === 'SHIPPING');
    if (shippingItem && shippingItem.total === 0) {
      return null;
    }

    const calculation = this.order.shipment.costCalculation as ShippingCostCalculation;

    const { costType, cost, minSpend, deltaSpend, currency } = calculation;

    if (costType === 'INDETERMINATE') return null;

    if (!cost) return null;

    if (deltaSpend) {
      return { deltaSpend, cost, currency };
    }

    if (minSpend) {
      return { minSpend, cost, currency };
    }

    return null;
  }
}
